// extracted by mini-css-extract-plugin
export default {"container":"Jl-z","bubbleNav":"Kl-z","graphic":"Ll-z","contact":"Ml-z"};